import type { AuthEventListener, AuthEventMap, AuthEventName, EventEmitter } from "../types";

/** Minimal typed event emitter. No external dependency, no global singleton. */
export class SimpleEventEmitter implements EventEmitter {
  private listeners = new Map<AuthEventName, Set<(payload: unknown) => void>>();

  on<E extends AuthEventName>(event: E, listener: AuthEventListener<E>): () => void {
    const set = this.listeners.get(event) ?? new Set();
    set.add(listener as (payload: unknown) => void);
    this.listeners.set(event, set);
    return () => set.delete(listener as (payload: unknown) => void);
  }

  emit<E extends AuthEventName>(event: E, payload: AuthEventMap[E]): void {
    const set = this.listeners.get(event);
    if (!set) return;
    for (const listener of set) listener(payload);
  }
}
